import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from "@mui/material";
import React, { useContext, useState } from "react";
import { FiAlertCircle, FiClipboard, FiClock, FiKey } from "react-icons/fi";
import { Route, Router, Switch, useHistory, useRouteMatch } from "react-router-dom";
import flex from "../../styles/flex";
import styles from "./KeyManager.module.css";
import usePaths from "../../utility/paths";

import { SessionContext } from "../../utility/useSession";
import DashPage from "../dash/DashPage";
import KeyAuditLocation from "./keyAudit/keyAuditLocation";
import KeyAuditHistory from "./KeyAuditHistory/KeyAuditHistory";
import KeyAuditsDue from "./keyAuditsDue/KeyAuditsDue";
import KeyMovementsScanner from "./keyMovements/components/KeyMovementsScanner";
import DynamicBoxMovements from "./dynamicBoxMovements/DynamicBoxMovements";
import { useTranslation } from "react-i18next";
import { RoutedKeyMovementsScanner } from "./keyMovements/components/RoutedKeyMovementsScanner";
import { usePreferences } from "../../utility/usePreferences";
import { ReleaseFlag, useReleaseManagement } from "../../utility/feature-management";


export const KeyManager = () => {
    const session = useContext(SessionContext);
    const history = useHistory();
    const { path } = useRouteMatch();

    const isImproveKeysScreenEnabled = useReleaseManagement(ReleaseFlag.releaseImproveKeysScreen);

    if (!session.current.site) {
        return <></>;
    }

    return (
        <DashPage>
            <Router history={history}>
                <Switch>
                    <Route exact path={`${path}/move`} component={RoutedKeyMovementsScanner} />
                    <Route component={isImproveKeysScreenEnabled ? MenuV2 : MenuV1} />
                </Switch>
            </Router>
        </DashPage>
    )
}

const MenuV1 = () => {
    const paths = usePaths();
    const history = useHistory();
    const { t } = useTranslation();

    const [showKeyManager, setShowKeyManager] = useState(true);
    const [showKeyMovement, setShowKeysIn] = useState(false);
    const [showDynamicBoxMovement, setShowDynamicBoxMovement] = useState(false);
    const [showKeyAudit, setShowKeyAudit] = useState(false);
    const [showKeyAuditsDue, setShowKeyAuditsDue] = useState(false);
    const [showKeyAuditHistory, setShowKeyAuditHistory] = useState(false);

    const releaseKeyAudit6342 = useReleaseManagement(ReleaseFlag.releaseKeyPositionAudit6342);
    const { enable_enforce_key_position_audit } = usePreferences();
    const isEnabledEnforceKeyPositionAudit = releaseKeyAudit6342 && enable_enforce_key_position_audit;
    const [enforceKeyAuditPosition, setEnforceKeyAuditPosition] = useState(false);

    return <>
        <Dialog open={showKeyManager} onClose={() => {
            history.push(paths.home);
        }}>
            <DialogTitle>
                {t("keys.labels.keys")}
            </DialogTitle>
            <DialogContent>
                <div className={styles.keyManagerDialog}>
                    <Button
                        onClick={() => {
                            setShowKeyManager(false);
                            setShowKeysIn(true);
                        }}
                    >
                        <div style={{ ...flex.flexColumns, marginTop: 20, marginBottom: 20 }}>
                            <div>
                                <FiKey size={40}></FiKey>
                            </div>
                            <div>
                                <b>{t("booking.labels.moveKeys")}</b>
                            </div>
                        </div>
                    </Button>

                    <Button
                        onClick={() => {
                            setEnforceKeyAuditPosition(false);
                            setShowKeyManager(false);
                            setShowKeyAudit(true);
                        }}
                    >
                        <div style={{ ...flex.flexColumns, marginTop: 20, marginBottom: 20 }}>
                            <div>
                                <FiClipboard size={40}></FiClipboard>
                            </div>
                            <div>
                                <b>{t(isEnabledEnforceKeyPositionAudit ? "keys.labels.startAuditByContents" : "keys.labels.startAudit")}</b>
                            </div>
                        </div>
                    </Button>

                    {isEnabledEnforceKeyPositionAudit && <Button
                        onClick={() => {
                            setEnforceKeyAuditPosition(true);
                            setShowKeyManager(false);
                            setShowKeyAudit(true);
                        }}
                    >
                        <div style={{ ...flex.flexColumns, marginTop: 20, marginBottom: 20 }}>
                            <div>
                                <FiClipboard size={40}></FiClipboard>
                            </div>
                            <div>
                                <b>{t("keys.labels.startAuditByOrder")}</b>
                            </div>
                        </div>
                    </Button>
                    }

                    <Button
                        onClick={() => {
                            setShowKeyManager(false);
                            setShowKeyAuditsDue(true);
                        }}
                    >
                        <div style={{ ...flex.flexColumns, marginTop: 20, marginBottom: 20 }}>
                            <div>
                                <FiAlertCircle size={40}></FiAlertCircle>
                            </div>
                            <div>
                                <b>{t("keys.labels.auditsDue")}</b>
                            </div>
                        </div>
                    </Button>

                    <Button
                        onClick={() => {
                            setShowKeyManager(false);
                            setShowKeyAuditHistory(true);
                        }}
                    >
                        <div style={{ ...flex.flexColumns, marginTop: 20, marginBottom: 20 }}>
                            <div>
                                <FiClock size={40}></FiClock>
                            </div>
                            <div>
                                <b>{t("booking.cards.history")}</b>
                            </div>
                        </div>
                    </Button>

                    <Button
                        onClick={() => {
                            setShowKeyManager(false);
                            setShowDynamicBoxMovement(true);
                        }}
                    >
                        <div style={{ ...flex.flexColumns, marginTop: 20, marginBottom: 20 }}>
                            <div>
                                <FiClock size={40}></FiClock>
                            </div>
                            <div>
                                <b>{t("keys.labels.moveDynamicBox")}</b>
                            </div>
                        </div>
                    </Button>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {
                    history.push(paths.home);
                }}>{t("general.cancel")}</Button>
            </DialogActions>
        </Dialog >

        <KeyMovementsScanner show={showKeyMovement} onClose={() => {
            setShowKeysIn(false);
            setShowKeyManager(true);
        }}></KeyMovementsScanner>

        <KeyAuditLocation show={showKeyAudit} enforceKeyPositionAudit={enforceKeyAuditPosition} onClose={() => {
            setShowKeyAudit(false);
            setShowKeyManager(true);
        }}></KeyAuditLocation>

        <KeyAuditsDue show={showKeyAuditsDue} onClose={() => {
            setShowKeyAuditsDue(false);
            setShowKeyManager(true);
        }}></KeyAuditsDue>

        <KeyAuditHistory show={showKeyAuditHistory} onClose={() => {
            setShowKeyAuditHistory(false);
            setShowKeyManager(true);
        }}></KeyAuditHistory>

        <DynamicBoxMovements show={showDynamicBoxMovement} onClose={() => {
            setShowDynamicBoxMovement(false);
            setShowKeyManager(true);
        }}></DynamicBoxMovements>

    </>
}

const MenuV2 = () => {
    const paths = usePaths();
    const history = useHistory();
    const { t } = useTranslation();

    const [dialogState, setDialogState] = useState({
        showKeyManager: true,
        showKeyMovement: false,
        showDynamicBoxMovement: false,
        showKeyAudit: false,
        showKeyAuditsDue: false,
        showKeyAuditHistory: false,
    });

    const releaseKeyAudit6342 = useReleaseManagement(ReleaseFlag.releaseKeyPositionAudit6342);
    const { enable_enforce_key_position_audit } = usePreferences();
    const isEnabledEnforceKeyPositionAudit = releaseKeyAudit6342 && enable_enforce_key_position_audit;
    const [enforceKeyAuditPosition, setEnforceKeyAuditPosition] = useState(false);

    const handleDialogToggle = (key: keyof typeof dialogState, value: boolean) => {
        setDialogState(prevState => ({ ...prevState, [key]: value }));
    };

    return (
        <>
            <Dialog open={dialogState.showKeyManager} onClose={() => history.push(paths.home)}>
                <DialogTitle>{t("keys.labels.keys")}</DialogTitle>
                <DialogContent>
                    <div className={styles.keyManagerDialogV2}>
                        {/* Move Keys Section */}
                        <div>
                            <h3>{t("keys.sections.moveKeys")}</h3>
                            <div className={styles.buttonContainer}>
                                <MenuButton
                                    icon={<FiKey size={40} />}
                                    label={t("booking.labels.moveKeys")}
                                    onClick={() => handleDialogToggle('showKeyMovement', true)}
                                />
                                <MenuButton
                                    icon={<FiClock size={40} />}
                                    label={t("keys.labels.moveDynamicBox")}
                                    onClick={() => handleDialogToggle('showDynamicBoxMovement', true)}
                                />
                            </div>
                        </div>

                        <Divider />

                        {/* Audits Section */}
                        <div>
                            <h3>{t("keys.sections.audits")}</h3>
                            <div className={styles.buttonContainer}>
                                <MenuButton
                                    icon={isEnabledEnforceKeyPositionAudit ? <UnorderedIcon size={40} /> : <FiClipboard size={40} />}
                                    label={t(isEnabledEnforceKeyPositionAudit ? "keys.labels.startAuditByContents" : "keys.labels.startAudit")}
                                    onClick={() => {
                                        setEnforceKeyAuditPosition(false);
                                        handleDialogToggle('showKeyAudit', true);
                                    }}
                                />
                                {isEnabledEnforceKeyPositionAudit && (
                                    <MenuButton
                                        icon={<OrderedIcon size={40} />}
                                        label={t("keys.labels.startAuditByOrder")}
                                        onClick={() => {
                                            setEnforceKeyAuditPosition(true);
                                            handleDialogToggle('showKeyAudit', true);
                                        }}
                                    />
                                )}
                                <MenuButton
                                    icon={<FiAlertCircle size={40} />}
                                    label={t("keys.labels.auditsDue")}
                                    onClick={() => handleDialogToggle('showKeyAuditsDue', true)}
                                />
                                <MenuButton
                                    icon={<FiClock size={40} />}
                                    label={t("booking.cards.history")}
                                    onClick={() => handleDialogToggle('showKeyAuditHistory', true)}
                                />
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => history.push(paths.home)}>{t("general.cancel")}</Button>
                </DialogActions>
            </Dialog>

            <KeyMovementsScanner show={dialogState.showKeyMovement} onClose={() => handleDialogToggle('showKeyMovement', false)} />
            <KeyAuditLocation show={dialogState.showKeyAudit} enforceKeyPositionAudit={enforceKeyAuditPosition} onClose={() => handleDialogToggle('showKeyAudit', false)} />
            <KeyAuditsDue show={dialogState.showKeyAuditsDue} onClose={() => handleDialogToggle('showKeyAuditsDue', false)} />
            <KeyAuditHistory show={dialogState.showKeyAuditHistory} onClose={() => handleDialogToggle('showKeyAuditHistory', false)} />
            <DynamicBoxMovements show={dialogState.showDynamicBoxMovement} onClose={() => handleDialogToggle('showDynamicBoxMovement', false)} />
        </>
    );
};

const MenuButton = ({ icon, label, onClick }: { icon: JSX.Element, label: string, onClick: () => void }) => (
    <Button onClick={onClick} style={{ height: "100%" }}>
        <div style={{ ...flex.flexColumns, marginTop: 20, marginBottom: 20, maxWidth: 115 }}>
            <div>{icon}</div>
            <div><b>{label}</b></div>
        </div>
    </Button>
);

const OrderedIcon: React.FC<{ size?: number }> = ({ size = 40 }) => (
    <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 16 16"
        height={`${size}px`}
        width={`${size}px`}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.287 2.326L2.692 2h.677v3h-.708V2.792l-.374.281v-.747zM5 3h10v1H5V3zm0 4h10v1H5V7zm10 4H5v1h10v-1zM3.742 7.626l.029-.039.065-.09a.84.84 0 0 0 .156-.507c0-.12-.02-.24-.057-.354a.848.848 0 0 0-.492-.529 1.123 1.123 0 0 0-.452-.082 1.094 1.094 0 0 0-.458.087.867.867 0 0 0-.479.522A1.038 1.038 0 0 0 2 6.957v.05h.81v-.05a.3.3 0 0 1 .046-.157.174.174 0 0 1 .057-.054.19.19 0 0 1 .172 0 .188.188 0 0 1 .056.06.24.24 0 0 1 .031.081.445.445 0 0 1-.036.29 1.309 1.309 0 0 1-.12.182l-1 1.138-.012.013v.54h1.988v-.7h-.9l.65-.724zm-.037 3.817c.046.032.086.07.12.114a.841.841 0 0 1 .167.55c0 .107-.017.213-.05.314a.792.792 0 0 1-.487.5 1.288 1.288 0 0 1-.48.079c-.115 0-.23-.016-.341-.049a.94.94 0 0 1-.258-.123.751.751 0 0 1-.182-.177 1.063 1.063 0 0 1-.116-.2A1.038 1.038 0 0 1 2 12.078v-.049h.814v.049c0 .027.003.055.009.082a.207.207 0 0 0 .03.074.14.14 0 0 0 .053.052.2.2 0 0 0 .157.008.159.159 0 0 0 .056-.039.22.22 0 0 0 .042-.075.417.417 0 0 0 .017-.126.483.483 0 0 0-.022-.163.2.2 0 0 0-.051-.08.138.138 0 0 0-.06-.029.537.537 0 0 0-.077-.007h-.161v-.645h.168a.241.241 0 0 0 .069-.011.164.164 0 0 0 .065-.034.175.175 0 0 0 .048-.067.286.286 0 0 0 .021-.121.28.28 0 0 0-.016-.1.166.166 0 0 0-.097-.099.2.2 0 0 0-.156.007.164.164 0 0 0-.055.053.344.344 0 0 0-.04.156v.049H2v-.049a.987.987 0 0 1 .18-.544.8.8 0 0 1 .179-.186.87.87 0 0 1 .262-.133c.114-.036.234-.053.354-.051.116-.001.231.01.344.036.092.021.18.055.263.1a.757.757 0 0 1 .32.318.73.73 0 0 1 .09.347.81.81 0 0 1-.167.528.562.562 0 0 1-.12.114z"
        ></path>
    </svg>
);

const UnorderedIcon: React.FC<{ size?: number }> = ({ size = 40 }) => (
    <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 16 16"
        height={`${size}px`}
        width={`${size}px`}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 3H1v1h1V3zm0 3H1v1h1V6zM1 9h1v1H1V9zm1 3H1v1h1v-1zm2-9h11v1H4V3zm11 3H4v1h11V6zM4 9h11v1H4V9zm11 3H4v1h11v-1z"
        ></path>
    </svg>
);
